import type { Invite } from "../../lib/api-types";

export type InviteStatus = "pending" | "expired";

/** An invitation is pending until its expiry passes. Accepted invitations are not listed here. */
export function inviteStatus(
  invite: Pick<Invite, "expiresAt">,
  now: number = Date.now(),
): InviteStatus {
  return new Date(invite.expiresAt).getTime() <= now ? "expired" : "pending";
}
